import 'datatables.net/js/jquery.dataTables';
import 'datatables.net-responsive/js/dataTables.responsive';

export default {
    init() {

        (function () {
            var profession = document.querySelector('[data-professiontype]');
            var resourceMini = $('.js-framework-contractor-table');

            if (!resourceMini.length) {
                return;
            }

            resourceMini.each(function () {
                var _self = $(this);

                _self.DataTable({
                    columnDefs: [
                        {
                            targets: 'no-sort',
                            orderable: false,
                            order: [],
                        },
                    ],
                    // Layout wrappers carry Tailwind classes directly — Tailwind scans this
                    // file. The elements DataTables generates inside them (filter,
                    // length, info, paginate) are styled in styles/standalone/datatables.css.
                    dom: '<"relative"' +
                        '<"mb-7.5 md:flex md:items-center gap-4"fl>' +
                        '<"mb-7.5 overflow-x-auto"rt>' +
                        '<"md:flex md:items-center gap-4"ip>' +
                        '>',
                    language: {
                        lengthMenu: 'Show <select>' +
                            '<option value="10">10 entities</option>' +
                            '<option value="20">20 entities</option>' +
                            '<option value="30">30 entities</option>' +
                            '<option value="40">40 entities</option>' +
                            '<option value="50">50 entities</option>' +
                            '<option value="-1">All entities</option>' +
                            '</select>',
                        search: "Search _INPUT_",
                        searchPlaceholder: "Type in " + profession.getAttribute('data-professiontype'),
                    },
                    pageLength: 10,
                });
            })

        }());

    },
    finalize() {

        (function () {

            var contractorRads = document.getElementsByName('table-selector'),
                areaImageBlock = document.getElementsByClassName('js-framework-contractors__area-images'),
                tableBlock = document.getElementsByClassName('js-framework-contractors__table-holder');

            if (!contractorRads.length)
                return;

            for (var i = 0; i < contractorRads.length; i++) {
                contractorRads[i].addEventListener('change', function () {

                    var targetTableID = this.value,
                        targetImageID = this.getAttribute('data-target-image');

                    showContractorImage(areaImageBlock, targetImageID);

                    showContractorTable(tableBlock, targetTableID);
                });
            }

            // sr-only replaces the old .hide class, which was itself an sr-only
            // mixin — the inactive blocks stay laid out rather than display:none so
            // DataTables can still measure the tables it has already initialised.
            function showOnly(container, targetID) {
                var children = container[0].children;

                for (var i = 0; i < children.length; i++) {
                    children[i].classList.add('sr-only');
                }

                document.getElementById(targetID).classList.remove('sr-only');
            }

            function showContractorImage(areaImageBlock, targetImageID) {
                showOnly(areaImageBlock, targetImageID);
            }

            function showContractorTable(tableBlock, targetTableID) {
                showOnly(tableBlock, targetTableID);
            }

        }());

    },
};
